// Global stacking contract for the automation underway popup.
//
// Policy (2026-07-16): the underway popup sits ABOVE only three candidate-review
// surfaces — the candidate application drawer (candidate-job-slider-v1), the
// candidate slider (ContactDetailsV2 / CandidateSlider), and the Quick App
// Review modal — and BEHIND every other drawer/modal. Those are the surfaces
// where you move/add a candidate, so the undo popup must stay visible over them;
// anywhere else the popup yields to whatever drawer is open.
//
// The ladder:
//
//   candidate surfaces (1360)  <  underway popup (1380)  <  drawers (1400)  <  modals (1440)  <  popover (1500)
//
// Achieved by (a) dropping the popup just below the default drawer band so every
// other drawer/modal covers it for free, and (b) lowering ONLY those three
// surfaces (overlay + positioning container together — lowering one alone leaves
// the overlay above the content and blocks the page) below the popup. Modals
// stay raised (theme/components/Modal.js) below `popover` (1500) so
// Popover/Menu/Select inside a modal keep working.

// The three candidate-review surfaces the popup sits ABOVE — lowered below it
// (overlay + content container together).
export const CANDIDATE_SURFACE_Z_INDEX = 1360;

// Underway popup when elevated: above the three candidate surfaces, below every
// other drawer/modal.
export const UNDERWAY_POPUP_Z_INDEX = 1380;

// Chakra `modal` token — every drawer stays here (above the popup).
export const DRAWER_Z_INDEX = 1400;

// Modal band, raised (see theme/components/Modal.js) above drawers and the
// popup, kept below `popover` (1500).
export const MODAL_Z_INDEX = 1440;
